export interface Form {
  readonly id: number;
  name?: string;
  state?: string;
  fields?: any;
}
